/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Result_Action_Email_DraftInputs */



/**
* | output |
* | --- |
* | "Draft an email in Outlook" |
*
* @param {Agent_Result_Action_Email_DraftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_result_action_email_draft = /** @type {((inputs?: Agent_Result_Action_Email_DraftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Result_Action_Email_DraftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("E-Mail-Entwurf in Outlook erstellen")
	return /** @type {LocalizedString} */ ("Draft an email in Outlook")
});